<form
  class="unit-economic-form"
  [formGroup]="unitEconomicFormGroup()"
>
  @for (field of unitEconomicsCalculationsFormFields; track $index) {
    @switch (field.type) {
      @case ('textarea') {
        <mat-form-field
          appearance="outline"
          [class]="getFieldClass()"
        >
          <mat-label>
            {{ field.label }}
          </mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            type="text"
            cdkAutosizeMinRows="4"
            cdkAutosizeMaxRows="4"
            [formControlName]="field.fieldName"
            (blur)="handleValueChange(field.fieldName)"
          ></textarea>
        </mat-form-field>
      }
      @case ('text') {
        <mat-form-field
          appearance="outline"
          [class]="getFieldClass()"
        >
          <mat-label>
            {{ field.label }}
          </mat-label>
          <input
            matInput
            type="text"
            [formControlName]="field.fieldName"
            (blur)="handleValueChange(field.fieldName)"
          >
        </mat-form-field>
      }
    }
  }
  @if (!unitEconomicData().id) {
    <div class="buttons-container">
      @if (noFirstData()) {
        <button
          mat-button
          color="warn"
          (click)="handleDeleteData()"
        >
          Удалить
        </button>
      }
      <button
        mat-button
        color="primary"
        [disabled]="unitEconomicFormGroup().invalid"
        (click)="handleCreateData()"
      >
        Сохранить
      </button>
    </div>
  }
</form>
